'use strict';

exports.__esModule = true;
var JSON_FORM_UI = exports.JSON_FORM_UI = {
  UI_WIDGET: 'ui:widget',
  UI_OPTIONS: 'ui:options',
  UI_DISABLED: 'ui:disabled',
  UI_HIDDEN: 'ui:hidden',
  UI_FORMAT: 'ui:format',
  UI_ON: 'ui:on',
  UI_NATIVE_ON: 'ui:nativeOn',
  UI_PARENT_COLUMN_ID: 'ui:parentColumnId',
  UI_RULES: 'ui:rules',
  UI_PLACEHOLDER: 'ui:placeholder',
  UI_COLSPAN: 'ui:colspan',
  UI_RULE: 'ui:rules',
  UI_RENDER: 'ui:render'
};

var COLUMN_TYPE = exports.COLUMN_TYPE = {
  INDEX: 'index'
};

var EDIT_TYPE = exports.EDIT_TYPE = {
  ADD: 'add',
  DELETE: 'delete',
  MODIFY: 'modify'
};

exports.default = {};